// extracted by mini-css-extract-plugin
export default {"modalOverlay":"eJ-z","modalContent":"fJ-z","header":"gJ-z","close":"hJ-z"};